import messages from './messages.js';

// const LEAVESTATUS_UNDEFINED = 0;
const LEAVESTATUS_DRAFT = 1;
const LEAVESTATUS_OPEN = 2;
export const LEAVESTATUS_REJECTED = 3;
export const LEAVESTATUS_ACCEPTED = 4;
const LEAVESTATUS_DELETED = 5;
const LEAVESTATUS_REVOKED = 6;

export const LEAVESTATUS_PROPS = {
  [LEAVESTATUS_DRAFT]: { style: 'primary', message: messages.draft },
  [LEAVESTATUS_OPEN]: { style: 'light', message: messages.submitted },
  [LEAVESTATUS_ACCEPTED]: { style: 'success', message: messages.approved },
  [LEAVESTATUS_REJECTED]: { style: 'danger', message: messages.rejected },
  [LEAVESTATUS_DELETED]: { style: 'light', message: messages.deleted },
  [LEAVESTATUS_REVOKED]: { style: 'light', message: messages.revoked },
};

export const CAN_EDIT_STATUS = [LEAVESTATUS_DRAFT];
export const CAN_DELETE_STATUS = [LEAVESTATUS_DRAFT, LEAVESTATUS_OPEN];

// const EMPLOYMENT_NOPAIDWORK = 0;
export const EMPLOYMENT_ENTREPRENEUR = 1;
export const EMPLOYMENT_EMPLOYED = 2;
